import React from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AddressProofGuideAnimation } from "../components/StepGuideAnimations";
import { KycStep } from "../components/KycStep";
import { StepFooter } from "../components/StepFooter";

export function AddressProofPreparationStep({ onBack, onContinue }) {
  const { t } = useTranslation();
  const tips = ["recent", "details", "complete"];
  return (
    <KycStep
      labelledBy="kyc-address-proof-preparation-title"
      className="kyc-preparation-step"
    >
      <div className="text-center">
        <AddressProofGuideAnimation />
        <h1
          id="kyc-address-proof-preparation-title"
          className="mt-6 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950 sm:text-[2rem]"
        >
          {t("kyc.addressProofPreparation.title")}
        </h1>
        <p className="mx-auto mt-3 max-w-md text-base leading-7 text-slate-600">
          {t("kyc.addressProofPreparation.description")}
        </p>
      </div>

      <ul className="mx-auto mt-6 max-w-md space-y-2.5">
        {tips.map((tip) => (
          <li
            key={tip}
            className="flex items-center gap-3 text-left text-sm leading-6 text-slate-600"
          >
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-teal-50 text-teal-700 ring-1 ring-teal-100">
              <Check
                className="size-3.5"
                strokeWidth={2.5}
                aria-hidden="true"
              />
            </span>
            {t(`kyc.addressProofPreparation.${tip}`)}
          </li>
        ))}
      </ul>

      <StepFooter
        onBack={onBack}
        onContinue={onContinue}
        continueLabel={t("kyc.addressProofPreparation.continue")}
        compact
      />
    </KycStep>
  );
}
